import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LuAdaptPositionModule } from 'lu-adapt-position-directive';
import { GroupByPipeModule } from 'lu-group-by-pipe';
import { LuIconModule } from 'lu-icon';
import { LuInfiniteScrollModule } from 'lu-infinite-scroll-directive';
import { SearchPipeModule } from 'lu-search-pipe';
import { DataService, ScrollService, SpinnerService } from 'lu-services';
import { ToastrService } from 'ngx-toastr';
import { LuSearchComponent } from './lu-search/lu-search.component';
import { LuSelectItemBasicComponent } from './lu-select-items/lu-select-item-basic/lu-select-item-basic.component';
import { LuSelectItemImageComponent } from './lu-select-items/lu-select-item-image/lu-select-item-image.component';
import { LuSelectItemWrapperComponent } from './lu-select-items/lu-select-item-wrapper';
import { LuSelectComponent } from './lu-select.component';
import { LuSelectModuleConfig, dataService, scrollService } from './lu-select.models';

const entryComponents = [LuSelectItemBasicComponent, LuSelectItemImageComponent];

@NgModule({
	imports: [
		CommonModule,
		LuIconModule,
		LuInfiniteScrollModule,
		TranslateModule,
		GroupByPipeModule,
		LuAdaptPositionModule,
		SearchPipeModule,
		LuSearchComponent
	],
	declarations: [LuSelectComponent, LuSelectItemWrapperComponent, ...entryComponents],
	exports: [LuSelectComponent]
})
export class LuSelectModule {
	static forRoot(config: LuSelectModuleConfig = {}): ModuleWithProviders<LuSelectModule> {
		return {
			ngModule: LuSelectModule,
			providers: [
				ScrollService,
				SpinnerService,
				ToastrService,
				HttpClient,
				config.dataService || {
					provide: dataService,
					useClass: DataService
				},
				config.scrollService || {
					provide: scrollService,
					useClass: ScrollService
				}
			]
		};
	}
}
